module.exports = __webpack_public_path__ + "static/Macroad-791baf99ca04f2233d9b29577a95530e.svg";